import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { bonus1, bonus2, bonus3, bonus4, bonus5 } from "../../assets";

const speakers = [
  { id: 1, img: bonus1 },
  { id: 2, img: bonus2 },
  { id: 3, img: bonus3 },
  { id: 4, img: bonus4 },
  { id: 5, img: bonus5 },
];

const Bonus: React.FC = () => {
  return (
    <Box sx={{ py: 10, px: 10, background: "#000" }}>

      <Box
        component="span"
        sx={{
          color: "#fff",
          fontSize: 22,
          fontWeight: 700,
          letterSpacing: 2,
          mr: 1,
        }}
      >
        Bonuses If
      </Box>

      <Typography
        variant="h3"
        sx={{
          background: "linear-gradient(90deg, #ffffff 0%, #d4af37 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          position: "relative",
          display: "inline-block",
          fontWeight: 700,
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: "0px",
            left: 0,
            width: "100%",
            height: "10px",
            background: "rgb(177 177 177 / 50%)",
            borderRadius: "4px",
          },
        }}
      >
        You Register{" "}
      </Typography>

      <Box
        component="span"
        sx={{
          color: "#fff",
          fontSize: 22,
          fontWeight: 700,
          letterSpacing: 2,
          ml: 1,
        }}
      >
        Before Timer Hits 0
      </Box>

      <Grid container spacing={6} alignItems="center" mt={4}>

        {/* LEFT SIDE */}
        <Grid item xs={12} lg={7}>
          <Grid container spacing={3} alignItems="flex-end">
            {speakers.map((speaker, index) => (
              <Grid
                item
                key={speaker.id}
                xs={12}
                sm={6}
                lg={
                  index === 0
                    ? 6
                    : index === 1
                      ? 4
                      : index === 2
                        ? 3
                        : index === 3
                          ? 5
                          : 4
                }
                sx={{
                  alignSelf:
                    index === 2 || index === 4
                      ? "flex-start"
                      : "flex-end",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 15px 35px rgba(255,255,255,0.08)",
                    background: "#000",
                  }}
                >
                  <Box
                    component="img"
                    src={speaker.img}
                    sx={{
                      width: "100%",
                      height: index === 0 ? "290px" : "100%",
                      objectFit: index === 0 ? "contain" : "cover",
                      display: "block",
                    }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* RIGHT SIDE */}
        <Grid item xs={12} lg={5}>
          <Box
            sx={{
              color: "#fff",
              position: "relative",
              p: 4,
              borderRadius: 3,
              background: "linear-gradient(145deg, #111, #000)",
              boxShadow: "0 20px 40px rgba(0, 131, 253, 0.15)",
            }}
          >
            <Typography
              variant="h3"
              fontWeight={800}
              mb={3}
              sx={{ color: "white" }}
            >
              Total Value :{" "}
              <Box
                component="span"
                sx={{
                  fontSize: "3.5rem",
                  color: "#0f63a5",
                  fontWeight: 900,
                }}
              >
                ₹2495/-
              </Box>
            </Typography>

            <Box
              sx={{
                display: "inline-block",
                position: "relative",
                background: "#0f63a5",
                px: 4,
                py: 1,
                fontWeight: 700,
                fontSize: "1.1rem",
                mb: 3,
                clipPath:
                  "polygon(0% 0%, 100% 0%, 95% 50%, 100% 100%, 0% 100%)",
                boxShadow: "0 5px 20px rgba(0,143,253,0.4)",
              }}
            >
              Get it for FREE TODAY
            </Box>

            <Typography mb={4} sx={{ opacity: 0.8, color: "white" }}>
              Reserve your seat before the timer ends to unlock bonuses
              worth ₹1,496/-
            </Typography>

            <Button
              fullWidth
              variant="contained"
              size="large"
              sx={{
                background: "linear-gradient(90deg, #0071fd, #458af2)",
                fontWeight: 700,
                py: 1.5,
                fontSize: "1rem",
                borderRadius: "50px",
                boxShadow: "0 10px 25px rgba(51, 51, 51, 0.5)",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 15px 35px rgba(0,143,253,0.4)",
                },
              }}
            >
              🔥 Register Now
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Bonus;